import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Partners.css';

function Partners() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [partnerData, setPartnerData] = useState({});
  const [activeTab, setActiveTab] = useState('upload');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [statusForm, setStatusForm] = useState({ title: '', description: '' });
  const [projectStatus, setProjectStatus] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('partnerToken');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsLoggedIn(true);
      fetchPartnerData();
      fetchFiles();
      fetchStatus();
    }
  }, []);

  const fetchPartnerData = async () => {
    try {
      const response = await axios.get('/api/partners/profile');
      setPartnerData(response.data);
    } catch (error) {
      console.error('Error fetching partner data:', error);
    }
  };

  const fetchFiles = async () => {
    try {
      const response = await axios.get('/api/partners/files');
      setUploadedFiles(response.data);
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await axios.get('/api/partners/status');
      setProjectStatus(response.data);
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/partners/login', loginForm);
      if (response.data.partner.status === 'locked') {
        alert('Your account is locked. Please contact admin.');
        return;
      }
      localStorage.setItem('partnerToken', response.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      setIsLoggedIn(true);
      setPartnerData(response.data.partner);
      fetchFiles();
      fetchStatus();
    } catch (error) {
      alert('Invalid partner credentials');
    }
  };

  const handleFileUpload = async (e) => {
    const formData = new FormData();
    Array.from(e.target.files).forEach(file => {
      formData.append('files', file);
    });

    try {
      await axios.post('/api/partners/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      fetchFiles();
      alert('Files uploaded successfully!');
    } catch (error) {
      alert('Error uploading files');
    }
  };

  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/partners/status', statusForm);
      setStatusForm({ title: '', description: '' });
      fetchStatus();
      alert('Status updated successfully!');
    } catch (error) {
      alert('Error updating status');
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="partner-login">
        <div className="login-container">
          <h1>🤝 Partner Login</h1>
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Partner Username"
              value={loginForm.username}
              onChange={(e) => setLoginForm({...loginForm, username: e.target.value})}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
              required
            />
            <button type="submit">Login as Partner</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="partner-dashboard">
      <header className="partner-header">
        <h1>🤝 Partner Dashboard - {partnerData.company}</h1>
        <div className="partner-info">
          <span>Welcome, {partnerData.username}</span>
          <button onClick={() => {
            localStorage.removeItem('partnerToken');
            setIsLoggedIn(false);
          }}>Logout</button>
        </div>
      </header>

      <nav className="partner-nav">
        <button 
          onClick={() => setActiveTab('upload')} 
          className={activeTab === 'upload' ? 'active' : ''}
        >
          📁 Upload Files
        </button>
        <button 
          onClick={() => setActiveTab('status')} 
          className={activeTab === 'status' ? 'active' : ''}
        >
          📝 Update Status
        </button>
        <button 
          onClick={() => setActiveTab('files')} 
          className={activeTab === 'files' ? 'active' : ''}
        >
          📋 My Files
        </button>
      </nav>

      <div className="partner-content">
        {activeTab === 'upload' && (
          <section className="upload-section">
            <h2>Upload Documents & Images</h2>
            <div className="upload-area">
              <input
                type="file"
                multiple
                onChange={handleFileUpload}
                accept="image/*,.pdf,.doc,.docx"
                id="file-upload"
              />
              <label htmlFor="file-upload" className="upload-label">
                📁 Choose Files to Upload
                <span>Images, PDFs, Documents</span>
              </label>
            </div>
          </section>
        )}

        {activeTab === 'status' && (
          <section className="status-section">
            <h2>Update Project Status</h2>
            <form onSubmit={handleStatusSubmit}>
              <input
                type="text"
                placeholder="Status Title"
                value={statusForm.title}
                onChange={(e) => setStatusForm({...statusForm, title: e.target.value})}
                required
              />
              <textarea
                placeholder="Status Description"
                value={statusForm.description}
                onChange={(e) => setStatusForm({...statusForm, description: e.target.value})}
                required
              />
              <button type="submit">Update Status</button>
            </form>

            <div className="status-history">
              <h3>Status History</h3>
              {projectStatus.map(status => (
                <div key={status.id} className="status-item">
                  <h4>{status.title}</h4>
                  <p>{status.description}</p>
                  <small>{new Date(status.date).toLocaleDateString()}</small>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeTab === 'files' && (
          <section className="files-section">
            <h2>Uploaded Files</h2>
            <div className="files-grid">
              {uploadedFiles.map(file => (
                <div key={file.id} className="file-item">
                  {file.originalname.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                    <img src={`/${file.filename}`} alt={file.originalname} />
                  ) : (
                    <div className="file-icon">📄</div>
                  )}
                  <p>{file.originalname}</p>
                  <small>{new Date(file.uploadDate).toLocaleDateString()}</small>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default Partners;
